import './../css/GameBox.css';
import teamLogos from '../assets/PLsoccerLogos';
import {Link} from 'react-router-dom'

const GameBox = ({ homeTeam, awayTeam, fullTime, statsLine }) => {
  const homeLogo = teamLogos[homeTeam];
  const awayLogo = teamLogos[awayTeam];
  const hasScore =
    fullTime &&
    fullTime.home != null &&
    fullTime.away != null &&
    !Number.isNaN(Number(fullTime.home)) &&
    !Number.isNaN(Number(fullTime.away));

  return (
    <div className="game-box">
      <div className="team team-home">
        <Link to={`/teams/premier-league/${homeTeam.replace(/ FC$| AFC$/, '').toLowerCase().replace(/\s+/g, '-')}`}>
          {homeLogo && (
            <img
              src={homeLogo}
              alt={`${homeTeam} logo`}
              className="team-logo"
            />
          )}
        </Link>
        <span className="team-name">{homeTeam}</span>
      </div>
      <div className="vs game-box-center">
        {hasScore ? (
          <span className="game-box-score">{fullTime.home} – {fullTime.away}</span>
        ) : (
          <span className="game-box-vs-label">vs</span>
        )}
        {statsLine ? (
          <span className="game-box-stats-line">{statsLine}</span>
        ) : null}
      </div>
      <div className="team team-away">
        <span className="team-name">{awayTeam}</span>
        <Link to={`/teams/premier-league/${awayTeam.replace(/ FC$| AFC$/, '').toLowerCase().replace(/\s+/g, '-')}`}>
          {awayLogo && (
            <img
              src={awayLogo}
              alt={`${awayTeam} logo`}
              className="team-logo"
            />
          )}
        </Link>
      </div>
    </div>
  );
};
export default GameBox;